import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { FormWithRedirect, useMutation, useNotify, useRefresh, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { AddEditCustomFieldBody } from "./AddEditCustomFieldBody";

export const AddCustomField = (props) => {
	const refresh = useRefresh();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();

	const [create, { loading }] = useMutation(
		{
			type: "create",
			resource: "custom-fields",
		},
		{
			onSuccess: () => {
				handleClose();
				refresh();
				notify(translate("osfc.dialogs.custom-fields.add.success"), "success");
			},
			onFailure: (error) => {
				notifyError(error);
			},
		}
	);

	const handleSubmit = (values) => {
		create({
			payload: {
				data: {
					...values,
					company_id: props.companyId,
				},
			},
		});
	};

	return (
		<>
			<Button
				aria-label="create"
				size="small"
				color="primary"
				startIcon={<AddIcon />}
				onClick={handleOpen}
			>
				{translate("resources.custom-fields.create-button")}
			</Button>
			{open && (
				<Dialog open={true} maxWidth="md" onClose={handleClose}>
					<DialogTitle>{translate("resources.custom-fields.create.title")}</DialogTitle>
					<FormWithRedirect
						submitOnEnter={false}
						component={DialogContent}
						save={handleSubmit}
						render={({ handleSubmitWithRedirect, form, record }) => (
							<React.Fragment>
								<AddEditCustomFieldBody form={form} />
								<DialogActions>
									<Button disabled={loading} onClick={handleClose} color="primary">
										{translate("ra.action.cancel")}
									</Button>
									<Button disabled={loading} onClick={handleSubmitWithRedirect} color="primary">
										{translate("ra.action.add")}
									</Button>
								</DialogActions>
							</React.Fragment>
						)}
					/>
				</Dialog>
			)}
		</>
	);
};
